import { Skeleton } from '@gov-nx/component/web';
import { useEasyFormContext } from '@gov-nx/module/service';
import { Dialog } from '@gov-nx/ui/web';
import { EasyFormModalContent } from './EasyFormModalContent';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import { EasyFormModalFooter } from './EasyFormModalFooter';

export const EasyFormModal = () => {
	const {
		onModalClose,
		name,
		isFetching,
		isFormSessionLoading,
		isSubmitButtonDisabled,
		formId,
		isModalFooterVisible,
	} = useEasyFormContext();
	const { Component } = LocalizeNameSpaceTypes;
	const { t } = useLocale(Component);

	return (
		<Dialog
			isOpen={true}
			blockBackdropClose={true}
			onClose={onModalClose}
			title={
				isFetching ? (
					<Skeleton
						width="100%"
						height="24px"
					/>
				) : (
					<h3>{name ?? t('stav.chyba.zadny-formular-nadpis')}</h3>
				)
			}
			footer={
				isModalFooterVisible ? (
					<EasyFormModalFooter
						isLoading={isFetching}
						isFormSessionLoading={isFormSessionLoading}
						isSubmitButtonDisabled={isSubmitButtonDisabled}
						formId={formId}
					/>
				) : undefined
			}>
			<EasyFormModalContent />
		</Dialog>
	);
};
